import React from 'react';
import { lazyLoadWithRetry } from '../utils/lazyLoadWithRetry';

const About = lazyLoadWithRetry(() => import('../pages/About'));
const Contact = lazyLoadWithRetry(() => import('../pages/Contact'));
const Login = lazyLoadWithRetry(() => import('../pages/Login'));
const NotFound = lazyLoadWithRetry(() => import('../pages/NotFound'));
const ErrorPage = lazyLoadWithRetry(() => import('../pages/ErrorPage'));
const HotelDetail = lazyLoadWithRetry(() => import('../pages/HotelDetail'));
const TravelerMarketing = lazyLoadWithRetry(
  () => import('../pages/TravelerMarketing')
);
const Profile = lazyLoadWithRetry(() => import('../pages/Profile'));
const TermsAndConditions = lazyLoadWithRetry(
  () => import('../pages/TermsAndConditions')
);
const PPPExplainer = lazyLoadWithRetry(() => import('../pages/PPPExplainer'));
const ImportFile = lazyLoadWithRetry(() => import('../pages/ImportFile'));
const PrivacyPolicy = lazyLoadWithRetry(() => import('../pages/PrivacyPolicy'));
const ForgotPassword = lazyLoadWithRetry(
  () => import('../pages/ForgotPassword')
);
const CheckEmailScreen = lazyLoadWithRetry(
  () => import('../components/Auth/CheckEmailScreen')
);
const ResetPassword = lazyLoadWithRetry(() => import('../pages/ResetPassword'));
const SampleQuestionnaire = lazyLoadWithRetry(
  () => import('../pages/SampleQuestionnaire')
);
const Hotels = lazyLoadWithRetry(() => import('../pages/Hotels'));
const CreateHotel = lazyLoadWithRetry(() => import('../pages/CreateHotel'));
const Dashboard = lazyLoadWithRetry(() => import('../pages/Dashboard'));
const HotelOrganizations = lazyLoadWithRetry(
  () => import('../pages/HotelOrganizations')
);
const HotelOrganizationDetail = lazyLoadWithRetry(
  () => import('../pages/HotelOrganizationDetail')
);
const BoostYourBusiness = lazyLoadWithRetry(
  () => import('../pages/BoostYourBusiness')
);

const ChangePassword = lazyLoadWithRetry(
  () => import('../pages/ChangePassword')
);

const PaymentStatus = lazyLoadWithRetry(() => import('../pages/PaymentStatus'));
const Users = lazyLoadWithRetry(() => import('../pages/Users'));
const RFPPage = lazyLoadWithRetry(() => import('../pages/RFPPage'));
const Enterprises = lazyLoadWithRetry(() => import('../pages/Enterprises'));
const EnterpriseDetail = lazyLoadWithRetry(
  () => import('../pages/EnterpriseDetail')
);
const Reporting = lazyLoadWithRetry(() => import('../pages/Reporting'));
const ProgramSummary = lazyLoadWithRetry(
  () => import('../pages/ProgramSummary')
);
const ProgramProperties = lazyLoadWithRetry(
  () => import('../pages/ProgramProperties')
);
const GlobalDirectory = lazyLoadWithRetry(
  () => import('../pages/GlobalDirectory')
);
const GDHotels = lazyLoadWithRetry(
  () => import('../components/EnterpriseAdmin/GlobalDirectory/GDHotels')
);

const EnterpriseReporting = lazyLoadWithRetry(
  () => import('../pages/EnterpriseReporting')
);
const NonHotelVenues = lazyLoadWithRetry(
  () => import('../pages/NonHotelVenues')
);
const ProgramBuilder = lazyLoadWithRetry(
  () => import('../pages/ProgramBuilder')
);
const BrandPerformace = lazyLoadWithRetry(
  () => import('../pages/BrandPerformace')
);
const CPV = lazyLoadWithRetry(() => import('../pages/EnterpriseCPV'));
const HotelView = lazyLoadWithRetry(
  () => import('../components/EnterpriseAdmin/ProgramProperties/HotelView')
);
const MarketsView = lazyLoadWithRetry(
  () => import('../components/EnterpriseAdmin/ProgramProperties/MarketsView')
);
const GDHotelView = lazyLoadWithRetry(
  () => import('../components/EnterpriseAdmin/GlobalDirectory/GDHotelView')
);

const IntegrationsAdmin = lazyLoadWithRetry(
  () => import('../pages/IntegrationsAdmin')
);

const Maintenance = lazyLoadWithRetry(() => import('../pages/Maintenance'));
const HotelBrands = lazyLoadWithRetry(() => import('../pages/HotelBrands'));
const HotelBrandDetail = lazyLoadWithRetry(
  () => import('../pages/HotelBrandDetail')
);
const BrandDashboard = lazyLoadWithRetry(
  () => import('../components/HotelBrands/BrandDashboard')
);
const BrandHotels = lazyLoadWithRetry(
  () => import('../components/HotelBrands/BrandHotels')
);
const EnterpriseHotels = lazyLoadWithRetry(
  () => import('../components/HotelBrands/EnterpriseHotels')
);

const BrandHotelDetail = lazyLoadWithRetry(
  () => import('../components/HotelBrands/HotelDetailView')
);

const BrandAdminReporting = lazyLoadWithRetry(
  () => import('../pages/BrandAdminReporting')
);

const ParentEnterprises = lazyLoadWithRetry(
  () => import('../pages/ParentEnterprises')
);
const ParentEnterpriseDetail = lazyLoadWithRetry(
  () => import('../pages/ParentEnterpriseDetail')
);

const TravellerCatalogGuide = lazyLoadWithRetry(
  () => import('../pages/TravellerCatalogGuide')
);
const SSOCallback = lazyLoadWithRetry(() => import('../pages/SSOCallback'));
const TravellerGuideMarketView = lazyLoadWithRetry(
  () => import('../pages/TravellerGuideMarketView')
);
const TravellerGuideHotelView = lazyLoadWithRetry(
  () => import('../pages/TravellerGuideHotelView')
);
const TravellerGuideLearnMore = lazyLoadWithRetry(
  () => import('../pages/TravellerGuideLearnMore')
);
const PublicTravellerGuideHotelView = lazyLoadWithRetry(
  () => import('../pages/PublicTravellerGuideHotelView')
);
const SSO = lazyLoadWithRetry(() => import('../pages/SSO'));
export interface RouteConfig {
  path: string;
  name: string;
  title: string;
  component: React.ComponentType;
  description?: string;
  protected?: boolean;
  props?: Record<string, any>;
}

export const routes: RouteConfig[] = [
  {
    path: '/login',
    name: 'login',
    title: 'Login',
    description: 'Sign in to your account',
    protected: false,
    component: Login,
  },
  {
    path: '/sso/:id',
    name: 'sso',
    title: 'Login with SSO',
    description: 'Sign in to your account',
    protected: false,
    component: SSO,
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    title: 'Forgot Password',
    description: 'Reset your password',
    protected: false,
    component: ForgotPassword,
  },
  {
    path: '/check-email',
    name: 'check-email',
    title: 'Check Your Email',
    description: 'Verify your email address',
    protected: false,
    component: CheckEmailScreen,
  },
  {
    path: '/change-password',
    name: 'change-password',
    title: 'Change Password',
    description: 'Change your password',
    protected: false,
    component: ChangePassword,
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    title: 'Reset Password',
    description: 'Set a new password',
    protected: false,
    component: ResetPassword,
  },
  {
    path: '/',
    name: 'home',
    title: 'Home',
    description: 'Welcome to your dashboard',
    protected: true,
    component: Dashboard, // Role-aware: Hotel Admin sees Hotels, Super Admin sees Home
  },
  {
    path: '/users',
    name: 'users',
    title: 'Users',
    description: 'Manage the users data',
    protected: true,
    component: Users,
  },
  {
    path: '/hotels',
    name: 'hotels',
    title: 'Hotels',
    description: 'Manage your hotels',
    protected: true,
    component: Hotels, // Hotels page with HotelsTable
  },
  {
    path: '/hotels/create',
    name: 'create hotels',
    title: 'Create Hotels',
    description: 'Create hotels',
    protected: true,
    component: CreateHotel,
  },
  {
    path: '/hotels/:id',
    name: 'hotel-detail',
    title: 'Hotel Detail',
    description: 'View and edit hotel information',
    protected: true,
    component: HotelDetail,
  },
  {
    path: '/hotels/:id/travel-marketing',
    name: 'hotel-travel-marketing',
    title: 'Hotel Travel Marketing',
    description: 'Manage travel marketing for the hotel',
    protected: false,
    component: TravelerMarketing,
  },
  {
    path: '/hotel-organizations',
    name: 'hotel-organizations',
    title: 'Hotel Organizations',
    description: 'Manage hotel organizations',
    protected: true,
    component: HotelOrganizations, // Hotels page with HotelsTable
  },
  {
    path: '/hotel-organizations/:id',
    name: 'hotel-organization-detail',
    title: 'Hotel Organization Detail',
    description: 'View and edit hotel organization information',
    protected: true,
    component: HotelOrganizationDetail,
  },
  {
    path: '/hotel-brands',
    name: 'hotel-brands',
    title: 'Hotel Brands',
    description: 'Manage hotel brands',
    protected: true,
    component: HotelBrands, // Hotels page with HotelsTable
  },
  {
    path: '/hotel-brands/:id',
    name: 'hotel-brand-detail',
    title: 'Hotel Brand Detail',
    description: 'View and edit hotel brand information',
    protected: true,
    component: HotelBrandDetail,
  },
  {
    path: '/enterprises',
    name: 'enterprises',
    title: 'Enterprises',
    description: 'Manage enterprises',
    protected: true,
    component: Enterprises,
  },
  {
    path: '/parent-enterprises',
    name: 'parent-enterprises',
    title: 'Parent Enterprises',
    description: 'Manage parent enterprises',
    protected: true,
    component: ParentEnterprises,
  },
  {
    path: '/enterprises/:id',
    name: 'enterprise-detail',
    title: 'Enterprise Detail',
    description: 'View and edit enterprise information',
    protected: true,
    component: EnterpriseDetail,
  },
  {
    path: '/parent-enterprises/:id',
    name: 'parent-enterprise-detail',
    title: 'Parent Enterprise Detail',
    description: 'View and edit parent enterprise information',
    protected: true,
    component: ParentEnterpriseDetail,
  },
  {
    path: '/reporting',
    name: 'reporting',
    title: 'Reporting',
    description: 'View reporting data',
    protected: true,
    component: Reporting,
  },
  {
    path: '/travel-managers/program-summary',
    name: 'program-summary',
    title: 'Program Summary',
    description: 'View program summary',
    protected: true,
    component: ProgramSummary,
  },
  {
    path: '/brand-admin/brand-dashboard',
    name: 'brand-dashboard',
    title: 'Brand Dashboard',
    description: 'View brand dashboard',
    protected: true,
    component: BrandDashboard,
  },
  {
    path: '/brand-admin/brand-hotels',
    name: 'brand-hotels',
    title: 'Brand Hotels',
    description: 'View brand hotels',
    protected: true,
    component: BrandHotels,
  },
  {
    path: '/brand-admin/brand-hotels/:brandName/:hotelId',
    name: 'brand-hotel-detail',
    title: 'Brand Hotel Detail',
    description: 'View brand hotel detail',
    protected: true,
    component: BrandHotelDetail,
  },
  {
    path: '/brand-admin/brand-dashboard/:brandName/enterprise-hotels/:enterpriseId',
    name: 'enterprise-hotels',
    title: 'Enterprise Hotels',
    description: 'View enterprise hotels',
    protected: true,
    component: EnterpriseHotels,
  },
  {
    path: '/brand-admin/brand-dashboard/:brandName/enterprise-hotels/:enterpriseId/:hotelId',
    name: 'brand-hotel-detail',
    title: 'Hotel Detail',
    description: 'View Hotel Detail',
    protected: true,
    component: BrandHotelDetail,
  },
  {
    path: '/brand-admin/reporting',
    name: 'brand-reporting',
    title: 'Brand Reporting',
    description: 'View brand reporting data',
    protected: true,
    component: BrandAdminReporting,
  },
  {
    path: '/brand-admin/ppp-explainer',
    name: 'ppp-explainer',
    title: 'PPP Explainer',
    description: 'View PPP Explainer',
    protected: true,
    component: PPPExplainer,
  },
  {
    path: '/travel-managers/program-properties',
    name: 'program-properties',
    title: 'Program Properties',
    description: 'View program properties',
    protected: true,
    component: ProgramProperties,
  },
  {
    path: '/travel-managers/global-directory',
    name: 'global-directory',
    title: 'Global Directory',
    description: 'View global directory',
    protected: true,
    component: GlobalDirectory,
  },
  {
    path: '/travel-managers/global-directory/:enterpriseId/hotels/:city/:countryCode/:state',
    name: 'global-directory-hotels-list',
    title: 'Global Directory Hotels List',
    description: 'View global directory hotels list',
    protected: true,
    component: GDHotels,
  },
  {
    path: '/travel-managers/global-directory/:enterpriseId/hotels/:id/:preferred?',
    name: 'global-directory-hotel-detail',
    title: 'Global Directory Hotel Detail',
    description: 'View global directory hotel detail',
    protected: true,
    component: GDHotelView,
  },
  {
    path: '/travel-managers/reporting',
    name: 'reporting',
    title: 'Reporting',
    description: 'View Reporting Data',
    protected: true,
    component: EnterpriseReporting,
  },
  {
    path: '/travel-managers/program-properties/:enterpriseId/hotels/:id',
    name: 'hotel-detail',
    title: 'Hotel Detail',
    description: 'View and edit hotel information',
    protected: true,
    component: HotelView,
  },
  {
    path: '/travel-managers/program-properties/:enterpriseId/markets/:city/:countryCode/:state',
    name: 'markets-detail',
    title: 'Markets Detail',
    description: 'View and edit markets information',
    protected: true,
    component: MarketsView,
  },

  {
    path: '/travel-managers/non-hotel-venues',
    name: 'non-hotel-venues',
    title: 'Non Hotel Venues',
    description: 'View Non Hotel Venues',
    protected: true,
    component: NonHotelVenues,
  },
  {
    path: '/travel-managers/program-builder',
    name: 'program-builder',
    title: 'Program Builder',
    description: 'Build and manage your programs',
    protected: true,
    component: ProgramBuilder,
  },
  {
    path: '/travel-managers/non-hotel-venues',
    name: 'non-hotel-venues',
    title: 'Non Hotel Venues',
    description: 'View Non Hotel Venues',
    protected: true,
    component: NonHotelVenues,
  },
  {
    path: '/travel-managers/brand-performance',
    name: 'brand-performance',
    title: 'Brand Performance',
    description: 'View Brand Performance',
    protected: true,
    component: BrandPerformace,
  },
  {
    path: '/travel-managers/cpv-insights',
    name: 'corporate-priority-view',
    title: 'Enterprise CPV Insights',
    description: 'View Enterprise CPV Insights',
    protected: true,
    component: CPV,
  },
  {
    path: '/maintenance',
    name: 'maintenance',
    title: 'Maintenance',
    description: 'Maintenance page',
    protected: true,
    component: Maintenance,
  },
  {
    path: '/upgrade',
    name: 'boost-your-business',
    title: 'Boost Your Business',
    description: 'Learn how to boost your business',
    protected: true,
    component: BoostYourBusiness,
  },
  {
    path: '/payment/:status',
    name: 'payment-status',
    title: 'Payment Status',
    description: 'Check the status of your payment',
    protected: true,
    component: PaymentStatus,
  },
  {
    path: '/import',
    name: 'import',
    title: 'Import File',
    description: 'Import your data files',
    protected: true,
    component: ImportFile,
  },
  {
    path: '/profile',
    name: 'profile',
    title: 'Profile',
    description: 'User profile',
    protected: true,
    component: Profile,
  },

  {
    path: '/about',
    name: 'about',
    title: 'About',
    description: 'Learn more about us',
    protected: true,
    component: About,
  },
  {
    path: '/help',
    name: 'contact',
    title: 'Contact',
    description: 'Get in touch with us',
    protected: true,
    component: Contact,
  },
  {
    path: '/sample-questionnaire',
    name: 'sample-questionnaire',
    title: 'Sample Questionnaire',
    description: 'Preview sample questionnaire',
    protected: true,
    component: SampleQuestionnaire,
  },
  {
    path: '/our-approach',
    name: 'ppp-explainer',
    title: 'PPP Explainer',
    protected: true,
    component: PPPExplainer,
  },
  {
    path: '/terms-of-use',
    name: 'terms-of-use',
    title: 'Terms of Use',
    protected: true,
    component: TermsAndConditions,
  },
  {
    path: '/privacy-policy',
    name: 'privacy-policy',
    title: 'Privacy Policy',
    description: 'Our privacy policy and data protection information',
    protected: true,
    component: PrivacyPolicy,
  },
  {
    path: '/500',
    name: 'error',
    title: 'Error',
    protected: true,
    component: ErrorPage,
  },
  {
    path: '/403',
    name: 'access-denied',
    title: 'Access Denied',
    protected: false,
    component: ErrorPage,
    props: {
      statusCode: 403,
      title: 'Access Denied',
    },
  },

  {
    path: '/rfp/:rfpLinkId',
    name: 'rfp',
    title: 'RFP Page',
    protected: false,
    component: RFPPage,
  },
  {
    path: '/rfp/:rfpLinkId/our-approach',
    name: 'rfp-our-approach',
    title: 'Our Approach',
    protected: false,
    component: PPPExplainer,
  },
  {
    path: '/rfp/:rfpLinkId/portal',
    name: 'rfp-portal',
    title: 'Portal',
    protected: false,
    component: PPPExplainer, // Replace with actual Portal component when available
  },
  {
    path: '/integrations/instructions',
    name: 'integrations-instructions',
    title: 'Integrations Instructions',
    protected: true,
    component: IntegrationsAdmin,
  },
  {
    path: '*',
    name: 'not-found',
    title: 'Not Found',
    protected: true,
    component: NotFound,
  },
  {
    path: '/sso/callback/:provider',
    name: 'sso-callback',
    title: 'SSO Callback',
    protected: false,
    component: SSOCallback,
  },
  {
    path: '/traveller-catalog-guide',
    name: 'traveller-catalog-guide',
    title: 'Traveller Catalog Guide',
    protected: true,
    component: TravellerCatalogGuide,
  },
  {
    path: `/traveller-catalog-guide/markets/:city/:countryCode/:state`,
    name: 'traveller-guide-market-view',
    title: 'Traveller Guide Market View',
    protected: true,
    component: TravellerGuideMarketView,
  },
  {
    path: `/traveller-catalog-guide/hotels/:hotelId`,
    name: 'traveller-guide-hotel-view',
    title: 'Traveller Guide Hotel View',
    protected: true,
    component: TravellerGuideHotelView,
  },
  {
    path: `/traveller-catalog-guide/learn-more`,
    name: 'traveller-guide-learn-more',
    title: 'Traveller Guide Learn More',
    protected: true,
    component: TravellerGuideLearnMore,
  },
  {
    path: `/traveller-catalog-guide/hotel/:linkId`,
    name: 'public-traveller-guide-hotel-view',
    title: 'Hotel Sustainability Profile',
    protected: false,
    component: PublicTravellerGuideHotelView,
  },
];

export const getRouteByPath = (path: string): RouteConfig | undefined => {
  return routes.find(route => route.path === path);
};

export const getRouteByName = (name: string): RouteConfig | undefined => {
  return routes.find(route => route.name === name);
};

export const getProtectedRoutes = (): RouteConfig[] => {
  return routes.filter(route => route.protected);
};

export const getPublicRoutes = (): RouteConfig[] => {
  return routes.filter(route => !route.protected);
};
